/** 발사체 sprite 0도 기준은 오른쪽(+x) — 속도 벡터를 그대로 회전각으로 쓴다. */
export function projectileHeadingRad(vx: number, vy: number, fallback: number): number {
  if (vx === 0 && vy === 0) return fallback;
  return Math.atan2(vy, vx);
}
